import { Preferences } from "@capacitor/preferences";

export const storage = {
  get: async (key: string): Promise<string | null> => {
    const { value } = await Preferences.get({ key });
    return value;
  },
  set: async (key: string, value: string): Promise<void> => {
    await Preferences.set({ key, value });
  },
  remove: async (key: string): Promise<void> => {
    await Preferences.remove({ key });
  },
};
